enum AddActions {
  AddRequest = 'settings/add-request',
  AddLastModified = 'settings/add-last-modified',
  AddError = 'settings/add-error'
}

export const LastModifiedActionTypes = {
  ...AddActions
};
